// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1u7E6","switch":"ToggleSwitch_switch__NP6GQ"};